export function getView() {
    return window.app.view
}
